import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { isDate } from 'lodash';
import { DLDocument } from './document';
import * as moment from 'moment-timezone';

interface DocumentItem {
  model: DLDocument
  date: FormControl
  comment: FormControl
}

@Component({
  selector: 'dl-document-form',
  templateUrl: './document-form.component.html',
})
export class DLDocumentFormComponent implements OnInit {
  @Input()
  document: DocumentItem

  initForm() {
    // date
    this.document.date = new FormControl(this.document.model.date, [
      Validators.required
    ]);

    this.document.date.valueChanges.subscribe((value) => {
      if(isDate(value)) {
        this.document.model.date = moment(value).format('YYYY-MM-DD');
      }
    });

    // comment
    this.document.comment = new FormControl(this.document.model.comment);

    this.document.comment.valueChanges.subscribe((value) => {
      this.document.model.comment = value;
    });
  }

  ngOnInit() {
    this.initForm()
  }
}
